/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MessageValidateAiCorrection } from '../../models/message-validate-ai-correction';

export interface ApiMessageValidateAiCorrectionItemIdPost$Params {
  item_id: number;
      body: MessageValidateAiCorrection
}

export function apiMessageValidateAiCorrectionItemIdPost(http: HttpClient, rootUrl: string, params: ApiMessageValidateAiCorrectionItemIdPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiMessageValidateAiCorrectionItemIdPost.PATH, 'post');
  if (params) {
    rb.path('item_id', params.item_id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiMessageValidateAiCorrectionItemIdPost.PATH = '/api/message/validate-ai-correction/{item_id}';
